<div class="bn-add-menu">
  <div class="bn-add-menu__column">
    <div class="bn-add-menu__title mb-2 ms-2">DELIVERY</div>

    @for (item of baseItems; track $index) {
      <ng-container *roleIds="item.roleIds">
        <ng-container *featureFlag="item.featureFlag">
          <ng-container *ngTemplateOutlet="menuItem; context: { item: item, type: 'delivery' }" />
        </ng-container>
      </ng-container>
    }
  </div>

  <div class="bn-add-menu__column">
    <div class="bn-add-menu__title mb-2 ms-2">EDGE PLATFORM</div>

    @for (item of computedItems; track $index) {
      <ng-container
        *roleIds="item.roleIds"
        (mouseenter)="onHover(item)">
        <ng-container *featureFlag="item.featureFlag">
          <ng-container *ngTemplateOutlet="menuItem; context: { item: item, type: 'compute' }" />
        </ng-container>
      </ng-container>
    }
  </div>

  @if (bannerItem) {
    <div class="bn-add-menu__column">
      <div class="bn-add-menu__banner">
        <img
          class="bn-add-menu__image"
          [src]="bannerItem.imageUrl" />
        <div class="bn-add-menu__banner__text mt-2">
          <div>
            <span class="bn-add-menu__tag"> {{ bannerItem.tag }} </span>
          </div>
          <div class="bn-add-menu__banner__title">{{ bannerItem.label }}</div>
          <div class="bn-add-menu__banner__description">{{ bannerItem.description }}</div>
          <div class="mb-4">
            <button
              bn-web-ui-button
              class="d-inline-block"
              itemStyle="stroke"
              size="sm"
              type="button"
              [fullWidth]="false"
              (click)="itemClickedEvent.emit(true)">
              {{ bannerItem.buttonLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<ng-template
  #menuItem
  let-item="item"
  let-type="type">
  <a
    [routerLink]="item.route"
    (click)="itemClickedEvent.emit(true)">
    @if (item.group === type) {
      <div>
        <div class="bn-add-menu__item">
          <div class="bn-add-menu__item__icon">
            <img [src]="item.icon" />
          </div>
          <div>
            <div class="bn-add-menu__item__title">{{ item.label }}</div>
            @if (item.description) {
              <div class="bn-add-menu__item__description">
                {{ item.description }}
              </div>
            }
          </div>
        </div>
      </div>
    }
  </a>
</ng-template>
